export const isDeepEqualNumberArray = (a: number[], b: number[]): boolean => {
  return (
    a.length === b.length &&
    new Set(a).size === new Set(b).size &&
    [...new Set(a)].every((n) => b.includes(n))
  );
};
